<template>
  <div id="sideMenu" class="mt-5">
    <div class="text-left" shadow>
      <div style="margin-bottom: 31px;">
        <p style="font-size: 24px" class="mb-0"><b>หมวดหมู่</b></p>
      </div>
      <div class="side-menu-border mb-5" style="padding: 10px;">
        <button v-for="item in category" :key="item.id" @click="categorytClick(item.id)" href="#" :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${$router.currentRoute.params.id == item.id ? 'btnActive' : ''
          }`">
          {{ item.name }}
        </button>
      </div>
      <!-- <p style="font-size: 24px" class=""><b>Ebook</b></p>
      <div class="side-menu-border mb-5" style="padding: 10px;">
        <button @click="categorytClick('Elibrary')" :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${($router.currentRoute.name == 'Elibrary') ? 'btnActive' : ''
          }`">
          E-library
        </button>
        <button @click="categorytClick('Eresearch')" :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${($router.currentRoute.name == 'Eresearch') ? 'btnActive' : ''
          }`">
          E-research
        </button>
      </div> -->
      <div class="side-menu-border mb-5" style="padding: 10px;">
        <button @click="categorytClick('allTeachers')" :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${$router.currentRoute.name == 'allTeachers' ? 'btnActive' : ''
          }`">
          ผู้สอนทั้งหมด
        </button>
      </div>
      <div class="side-menu-border mb-5" style="padding: 10px;">
        <button @click="categorytClick('allCourses')" :class="`btn btn-outline-white btn-block side-menu text-left pl-0 btnHover ${($router.currentRoute.name == 'allCourses') && !($router.currentRoute.params.id ? $router.currentRoute.params.id : false) ? 'btnActive' : ''
          }`">
          คอร์สเรียนทั้งหมด
        </button>
      </div>

    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "sideMenu",
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      category: (state) => state.Category.category,
      group: (state) => state.Group.group,
    }),
  },
  created() {
    this.getCategory();
    this.getGroup();
  },

  methods: {
    async getCategory() {
      await this.$store.dispatch("Category/getCategory");
    },
    async getGroup() {
      await this.$store.dispatch("Group/getGroup");
    },
    async categorytClick(id) {
      this.isLoading = true;

      if (id == "allCourses") {
        let path = `/all-courses`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      } else if (id == "allTeachers") {
        let path = `/all-teachers`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      } else if (id == "favoriteMenuEbook") {
        let path = `/favorite-menu-book/${id}`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      }
      else if (id == "Elibrary") {
        let path = `/e-library`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      }
      else if (id == "Eresearch") {
        let path = `/e-research`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      } else {
        // await this.$store.dispatch("Courses/getAllCourse", {favorite-menu-book
        //   category: id,
        //   keyword: null,
        // });
        let path = `/category/${id}`;
        this.isLoading = false;
        await this.$router.push({
          path: path,
        });
      }

      this.isLoading = false;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 990px) {
  #sideMenu {
    display: none;
  }
}

.side-menu-border>button {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

/*button.side-menu:hover {*/
/*  background-color: #2c3143; !* Green *!*/
/*  color: white;*/
/*}*/
</style>
